'use client';

import { useEffect, useRef, type ReactNode, type CSSProperties } from 'react';

interface ParallaxTextProps {
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

/** Ported as-is from scripts.js banner 10 — scroll-linked translateY, speed 0.05. */
export default function ParallaxText({ className, style, children }: ParallaxTextProps) {
  const ref = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      const el = ref.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const speed = 0.05;
      const offset = (window.innerHeight / 2 - rect.top) * speed;
      el.style.transform = `translateY(${offset}px)`;
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <h2 ref={ref} className={`parallax-text${className ? ` ${className}` : ''}`} style={style}>
      {children}
    </h2>
  );
}
